import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import { benefitsHiringCard, emissorBenefitsHiringCard } from '@ibk/shared-assets';
import { ContentLayout, StepperCard } from '@ibk/shared-layout';
import { useTranslation } from '@ibk/shared-translation';
import { AddressCard } from '../../../../components/AddressCard';
import { useCompanyAddress } from '../../../../hooks/useCompanyAddress';
import { HiringStep, SidebarStatus } from '../../../../types/hiring';
import { ContractSummarySidebar } from '../ContractSummarySidebar';
import styles from './HiringAddress.module.css';
export function HiringAddress({ onComplete, onBack, isLoadingPartner, isPatEnabled = false, sidebarSteps, address, productFamilies, stepNumber, headerStepper, isEmissorFlow = false, }) {
    const { t } = useTranslation();
    const { currentLocation, isLoading: isLoadingAddress, isSaving, saveLocation } = useCompanyAddress();
    const breadcrumbs = [
        { label: t('hiring.breadcrumb.benefits'), href: '/beneficios' },
        { label: t('hiring.breadcrumb.hiring'), isActive: true },
    ];
    const currentStep = {
        id: HiringStep.ADDRESS,
        title: t('hiring.step.address'),
        number: stepNumber ?? 1,
        status: SidebarStatus.ACTIVE,
    };
    const handleBack = () => {
        if (onBack) {
            onBack();
            return;
        }
        window.history.back();
    };
    const handleNext = useCallback(() => {
        if (!currentLocation?.locationId) {
            console.error(t('contract.error.location-not-found'));
            return;
        }
        onComplete(currentLocation.locationId);
    }, [onComplete, currentLocation, t]);
    const renderMainCard = () => (_jsxs(StepperCard, { currentStep: currentStep, showStepper: !headerStepper, actions: {
            back: {
                label: t('hiring.button.back'),
                onClick: handleBack,
            },
            next: {
                label: t('hiring.button.next'),
                onClick: handleNext,
                disabled: !currentLocation?.locationId || isLoadingAddress || isLoadingPartner,
            },
        }, children: [headerStepper, _jsxs("div", { className: styles.stepContent, "data-testid": 'viewHiringAddressStepContent', children: [!isPatEnabled && (_jsx("div", { className: styles.cardIllustration, "data-testid": 'viewHiringAddressCardIllustration', children: _jsx("img", { src: isEmissorFlow ? emissorBenefitsHiringCard : benefitsHiringCard, alt: t('hiring.card.alt'), className: `${styles.cardImage} ${isEmissorFlow ? styles.emissorCardImage : ''}`, "data-testid": 'imageHiringAddressBenefitsCard' }) })), _jsxs("div", { className: styles.explanation, "data-testid": 'viewHiringAddressExplanation', children: [_jsx("h3", { className: styles.title, "data-testid": 'textHiringAddressTitle', children: t('hiring.title') }), _jsx("p", { className: styles.subtitle, "data-testid": 'textHiringAddressSubtitle', children: t('hiring.subtitle') })] }), _jsx(AddressCard, { loading: isLoadingAddress, showEditButton: true, title: t('address.company.title'), modalTitle: t('address.company.title'), isHiring: true, location: currentLocation, onSave: async (address) => {
                            await saveLocation({
                                locationType: address.locationType,
                                address: address.address,
                                number: address.number,
                                zipCode: address.zipCode,
                                city: address.city,
                                state: address.state,
                                country: address.country,
                                complement: address.complement,
                                addressLine2: address.addressLine2,
                            });
                        }, isSaving: isSaving, testIdIdentifier: 'HiringAddressAddressCard' })] })] }));
    const renderSummaryCard = () => (_jsx(ContractSummarySidebar, { steps: sidebarSteps, address: address, productFamilies: productFamilies }));
    if (headerStepper) {
        return (_jsx(ContentLayout, { breadcrumbs: breadcrumbs, showSidebar: false, noMaxWidth: true, "data-testid": 'viewHiringPageContainer', children: renderMainCard() }));
    }
    return (_jsx(ContentLayout, { breadcrumbs: breadcrumbs, sidebar: renderSummaryCard(), "data-testid": 'viewHiringPageContainer', children: renderMainCard() }));
}
